module.exports = __webpack_public_path__ + "img/81600.7a05f365.jpg";